import { Tooltip } from 'antd';
import React from 'react';

interface UrlParserProps {
  text: string;
}

const UrlParser: React.FC<UrlParserProps> = ({ text }) => {
  const parseUrls = (inputText: string) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return inputText?.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <Tooltip title={part.length > 150 ? `${part.substring(0, 150)}...` : part}>
            <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part.length > 30 ? `${part.substring(0, 30)}...` : part}
            </a>
        </Tooltip>
      ) : (
        part
      )
    );
  };

  return <div style={{ whiteSpace: 'pre-line' }}>{parseUrls(text)}</div>;
};

export default UrlParser;
